// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__38RyL","title":"ClientReferral_title__3fidO","itemText":"ClientReferral_itemText__3C8-O"};